module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.comp) ? _c('div', [_c(_vm.comp, _vm._b({
    tag: "component"
  }, 'component', {
    stats: _vm.getStats()
  }, false))], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02eaf2d7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomePage.vue
// module id = 1389
// module chunks = 0